import { CONTROL } from '../../../../components';
import { getObs, UnitsOfCalculationItem } from '../../../utils/obs';
var StorageClassItem = {
  VirtualServer: 'Virtual server',
  Volume: 'Volume',
  SFSTurbo: 'SFS Turbo'
};
var storageClassItems = [{
  value: StorageClassItem.VirtualServer,
  label: 'Virtual server',
  description: 'Предназначен для сервисов Elastic Cloud Server (ECS) и Bare Metal Server (BMS), с помощью которого осуществляется бэкап системных дисков и дисков с данными.'
}, {
  value: StorageClassItem.Volume,
  label: 'Volume',
  description: 'Предназначен для сервиса Elastic Volume Sevice (EVS), с помощью которого осуществляется бэкап системных дисков или дисков с данными.'
}, {
  value: StorageClassItem.SFSTurbo,
  label: 'SFS Turbo',
  description: 'Предназначен для сервиса Scalable File Service (SFS), с помощью которого осуществляется бэкап файлового хранилища.'
}];
export var CLOUD_BACKUP_FORM_CONFIG = {
  ui: ['serviceAlert', 'service', ['storage']],
  controls: {
    serviceAlert: {
      type: CONTROL.Alert,
      uiProps: {
        description: 'Рекомендуем выбирать объем хранилища под бэкапы на 20% больше объема самого продукта'
      },
      accessorKey: 'cbr.alert'
    },
    service: {
      type: CONTROL.Carousel,
      defaultValue: StorageClassItem.VirtualServer,
      items: storageClassItems,
      accessorKey: 'cbr.service',
      decoratorProps: {
        label: 'Тип продукта'
      }
    },
    storage: getObs({
      space: {
        accessorKey: 'cbr.storage.space',
        label: 'Размер хранилища',
        defaultValue: 1,
        uiProps: {
          min: 1,
          max: 9999998976
        },
        relateFn: function relateFn(_ref) {
          var unitsOfCalculation = _ref.unitsOfCalculation;
          if (unitsOfCalculation === UnitsOfCalculationItem.Tb) {
            return {
              uiProps: {
                max: 9765624,
                postfix: 'ТБ'
              }
            };
          }
        }
      },
      units: {
        accessorKey: 'cbr.storage.unitsOfCalculation',
        defaultValue: 'gb'
      }
    })
  }
};